import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { breakpoint, theme, breakpointMap } from '../../theme';
import { panelColor } from './helpers';
import { InfoPanelSize, InfoPanelType } from './types';


const StyledPanel = styled.article<{ panelSize: InfoPanelSize }>`
  display: flex;
  align-items: flex-start;
  background-color: ${({ color }) => color};
  border-radius: ${theme.borderRadius.default};
  padding: ${theme.spacings[3].rem};

  ${({ panelSize }) =>
    breakpointMap(panelSize, (size) =>
      size === 'sm'
        ? css`
            padding: ${theme.spacings[2].rem} ${theme.spacings[3].rem};
          `
        : css`
            padding: ${theme.spacings[3].rem};
            ${breakpoint('sm')`
              padding: ${theme.spacings[4].rem};
            `};
          `
    )}
`;

export type InfoPanelContainerProps = PropsWithChildren<{
  type: InfoPanelType;
  size: InfoPanelSize;
}>;

export const InfoPanelContainer: React.FC<InfoPanelContainerProps> = ({
  children,
  type,
  size,
}) => (
  <StyledPanel panelSize={size} color={panelColor(type)}>
    {children}
  </StyledPanel>
);
